<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_6420_102)">
      <path
        d="M14.1162 9.11621C14.6044 8.62806 15.3956 8.62806 15.8838 9.11621L20.8838 14.1162C21.3719 14.6044 21.3719 15.3956 20.8838 15.8838L15.8838 20.8838C15.3956 21.3719 14.6044 21.3719 14.1162 20.8838C13.6281 20.3956 13.6281 19.6044 14.1162 19.1162L16.9824 16.25H8C6.60761 16.25 5.27265 15.6965 4.28809 14.7119C3.30352 13.7273 2.75 12.3924 2.75 11V4C2.75 3.30964 3.30964 2.75 4 2.75C4.69036 2.75 5.25 3.30964 5.25 4V11C5.25 11.7293 5.53994 12.4286 6.05566 12.9443C6.57139 13.4601 7.27065 13.75 8 13.75H16.9824L14.1162 10.8838C13.6281 10.3956 13.6281 9.60437 14.1162 9.11621Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<script>
export default { name: 'CornerDownRight' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
